import { usePageContext } from 'vike-react/usePageContext'
import { ComingSoon } from '../../components/ComingSoon.js'
import PracticePage from '../practice/+Page.js'

export default function Page() {
  const pageContext = usePageContext()
  if ((pageContext.routeParams as any)?.comingSoon === 'true') {
    return <ComingSoon language={(pageContext.routeParams as any).language}/>
  }
  return <PracticePage/>
}
